<div class="x_title">
  <h2>
    <ng-content></ng-content>
  </h2>
  <ng-container>
    <ng-content select="[panel-button]"></ng-content>
  </ng-container>
  <div class="clearfix"></div>
</div>
